import moment from 'moment';
import React from 'react';
import Swal from 'sweetalert2';
import { url } from '../baseURL';
import { detectMimeType, fetchFileFromUrl } from '../services/httpService';


export const getDataObj = (arr = [], id) => {
    let data = arr.find((element) => {
        return id == element.id
    });
    return data;
}


export const getInvestorName = (investorId, investorList) => {
    const investor = investorList.find((investor) => Number(investorId) === investor.id);
    if (investor && Object.keys(investor).length > 0) {
        return investor?.name ? investor.name : investor.id;
    }
    else {
        return "None";
    }
}

export const getUserPermission = (url, userRoleMenuList) => {
    // Add date for permissions
    let roleMenuData = userRoleMenuList.find((item) => item.menu.menuUrl == url);
    if (roleMenuData) {
        return true;
    } else {
        return false;
    }
}

export const getCouponParamName = (couponParamId, couponsParamList) => {
    const couponParam = couponsParamList.find((couponParam) => couponParamId === couponParam.id);
    if (couponParam && Object.keys(couponParam).length > 0) {
        return `${couponParam.id} - ${moment(moment(couponParam.investmentStartDate).toDate()).format("YYYY-MM-DD")} - ${moment(moment(couponParam?.investmentMaturityDate).toDate()).format("YYYY-MM-DD")}`;
    }
    else {
        return "None";
    }
}

export const openDoc = (myfile) => {
    console.log("myfile", myfile);
    let tokenHeader = "";
    if (localStorage.getItem("_token")) {
        tokenHeader = localStorage.getItem("_token");
    }

    let data = {
        id: myfile
    }
    var requestOptions = {
        method: "POST",
        body: JSON.stringify(data),
        headers: { Authorization: tokenHeader, "Content-Type": "application/json", },
        redirect: 'follow'
    };
    if (myfile == null) {
        Swal.fire({
            title: "Error",
            text: "File not found",
            timer: 2000,
            icon: "error"
        })
    } else {
        fetch(`${url}/pfpclient/docView`, requestOptions)
            .then(response => response.json())
            .then(async (result) => {
                console.log(result);
                if (result.success) {
                    var win = window.open();
                    win.document.write('<iframe src="' + `data:${result.body.content[0].docType};base64,${result.body.content[0].base64Doc}` + '" frameborder="0" style="border:0; top:0px; left:0px; bottom:0px; right:0px; width:100%; height:100%;" allowfullscreen></iframe>');
                }

            })
            .catch((error) => {
                console.log("error", error);
                Swal.fire({
                    title: "Error",
                    text: error,
                    timer: 2000,
                    icon: "error"
                })
            });
    }
};

export const getSelectedTransaction = (transactionId, allTransactions) => {
    const transaction = allTransactions.find((transaction) => transactionId === transaction.id);
    if (transaction && Object.keys(transaction).length > 0) {
        return `${transaction.id} - ${moment(transaction.transactionDate).format("YYYY-MM-DD")}`;
    }
    else {
        return "None";
    }
}

export const getSelectedCommitment = (commitmentId, commitmentList) => {
    const commitment = commitmentList.find((commitment) => commitmentId === commitment.id);
    if (commitment && Object.keys(commitment).length > 0) {
        return `${commitment.id} - ${moment(commitment.startDate).format("YYYY-MM-DD")} - ${moment(commitment.endDate).format("YYYY-MM-DD")} (${commitment.status})`;
    }
    else {
        return "None";
    }
}

export const DocView = async (e, filePath) => {
    e.preventDefault();
    try {
      if (filePath) {
        console.log('filePath', filePath);
        let result = await fetchFileFromUrl(filePath)
        if (result.success) {
          const bytes = atob(result.body);
          let length = bytes.length;
          let out = new Uint8Array(length);
          while (length--) {
            out[length] = bytes.charCodeAt(length);
          }
          const blob = new Blob([out], { type: detectMimeType(filePath, filePath) });
          let fileURL = window.URL.createObjectURL(blob);
          window.open(fileURL, '_blank');
        }

      }
    } catch (error) {
      console.log("Doc Load Exception", error)
      alert(error)
    }
}

export const utcMoment = (date,format=false) => {
    console.log('date-utc',date);
    var utcDate = Math.floor(new Date(date).getTime() / 1000);

    console.log('utcDate-utc',utcDate);

    // let changeDate = moment.unix(utcDate).utcOffset('+0400').set({ hour: 0, minute: 0, second: 0, millisecond: 0 }).format("YYYY-MM-DDTHH:mm:ssZ")
    // let changedDate = format ? moment.unix(utcDate).utc().format("yyyy-MM-DD") : moment.unix(utcDate).utc().format("YYYY-MM-DDTHH:mm:ssZ")

    let changedDate = format ? moment.unix(utcDate).utcOffset('+0400').set({ hour: 0, minute: 0, second: 0, millisecond: 0 }).format("YYYY-MM-DDTHH:mm:ssZ") : moment.unix(utcDate).utc().format("YYYY-MM-DDTHH:mm:ssZ");
    console.log('changedDate',changedDate);
    return changedDate;
}

export const utcFillterMoment =(date) =>{
    var conDate = moment(date).format("YYYY-MM-DD");
    var utcDate = Math.floor(new Date(conDate).getTime() / 1000);
    var changDD = moment.unix(utcDate).utcOffset('+0400').set({ hour: 0, minute: 0, second: 0, millisecond: 0 }).format("YYYY-MM-DDTHH:mm:ssZ");

    return changDD;
}

export const amountViewFormat = (amount) =>{
   const convrtAmount =  (amount && amount > 0) ? Number(amount).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',') : '0.00';
   return convrtAmount;
}
